/*
 * @Author: w-lichenxia-8caYS w_lichenxia@xiwang.com
 * @Date: 2024-06-11 16:20:49
 * @LastEditors: Shusheng
 * @LastEditTime: 2024-08-22 15:06:15
 * @FilePath: /teacher-desk/src/config/env.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Brand } from '@/api/type';
const brand = localStorage.getItem('Teacher-Desk-X-BRAND') || Brand.xwx;
export const isXwx = +brand === +Brand.xwx;
export const isXwsy = +brand === +Brand.xwxsy;
export const isDev = import.meta.env.VITE_APP_ENV === 'dev';
export const isTest = import.meta.env.VITE_APP_ENV === 'test';
export const isGray = import.meta.env.VITE_APP_ENV === 'gray';
export const isProd = import.meta.env.VITE_APP_ENV === 'prod';
